import { all, fork, call, put, takeLatest } from 'redux-saga/effects'
import { constants } from '../../modules/jobFunctions/jobAgreementActions'
import * as api from '../../api/job/agreement'

function* agreementRefresh(action) {
  try {
    const params = {
      jobId: action.jobId,
      folderId: action.folderId || null
    }
    const payload = yield call(api.fetchAgreements, params)
    yield put({ type: constants.AGREEMENT_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.AGREEMENT_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchAgreement() {
  yield takeLatest(constants.AGREEMENT_REFRESH.ACTION, agreementRefresh)
}

function* sagaCreateAgreement(action) {
  try {
    const payload = {
      formData: action.formData
    }
    yield call(api.createJobAgreement, payload)
    yield put({ type: constants.AGREEMENT_CREATE.SUCCESS, payload })
    yield call(agreementRefresh, { jobId: action.jobId, folderId: action.folderId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.AGREEMENT_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateAgreement() {
  yield takeLatest(constants.AGREEMENT_CREATE.ACTION, sagaCreateAgreement)
}

function* sagaUpdateAgreement(action) {
  try {
    const payload = {
      formData: action.formData,
      agreementId: action.agreementId
    }
    yield call(api.updateJobAgreement, payload)
    yield put({ type: constants.AGREEMENT_UPDATE.SUCCESS, payload })
    yield call(agreementRefresh, { jobId: action.jobId, folderId: action.folderId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.AGREEMENT_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAgreement() {
  yield takeLatest(constants.AGREEMENT_UPDATE.ACTION, sagaUpdateAgreement)
}

function* sagaDeleteAgreement(action) {
  try {
    yield call(api.deleteJobAgreement, { agreementId: action.agreementId })
    yield put({ type: constants.AGREEMENT_DELETE.SUCCESS })
    yield call(agreementRefresh, { jobId: action.jobId, folderId: action.folderId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.AGREEMENT_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAgreement() {
  yield takeLatest(constants.AGREEMENT_DELETE.ACTION, sagaDeleteAgreement)
}

function* uploadAgreementAttachments(action) {
  try {
    const payload = yield call(api.uploadAttachments, { formData: action.formData })
    yield put({ type: constants.UPLOAD_AGREEMENT_ATTACHMENT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_AGREEMENT_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadAgreementAttachments() {
  yield takeLatest(constants.UPLOAD_AGREEMENT_ATTACHMENT.ACTION, uploadAgreementAttachments)
}

function* createFolder(action) {
  try {
    const payload = {
      name: action.name,
      parentId: action.parentId,
      jobId: action.jobId
    }

    yield call(api.createFolder, payload)
    yield put({ type: constants.AGREEMENT_FOLDER_CREATE.SUCCESS, payload })
    yield call(agreementRefresh, { jobId: action.jobId, folderId: action.folderId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.AGREEMENT_FOLDER_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateFolder() {
  yield takeLatest(constants.AGREEMENT_FOLDER_CREATE.ACTION, createFolder)
}

function* updateFolder(action) {
  try {
    const payload = {
      name: action.name,
      folderId: action.folderId
    }

    yield call(api.updateFolder, payload)
    yield put({ type: constants.AGREEMENT_FOLDER_UPDATE.SUCCESS, payload })
    yield call(agreementRefresh, { jobId: action.jobId, folderId: action.currentFodlerId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.AGREEMENT_FOLDER_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateFolder() {
  yield takeLatest(constants.AGREEMENT_FOLDER_UPDATE.ACTION, updateFolder)
}

function* deleteFolder(action) {
  try {
    const payload = {
      folderId: action.folderId,
      jobId: action.jobId
    }

    yield call(api.deleteFolder, payload)
    yield put({ type: constants.AGREEMENT_FOLDER_DELETE.SUCCESS, payload })
    yield call(agreementRefresh, { jobId: action.jobId, folderId: action.currentFolderId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.AGREEMENT_FOLDER_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteFolder() {
  yield takeLatest(constants.AGREEMENT_FOLDER_DELETE.ACTION, deleteFolder)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchAgreement),
    fork(watchCreateAgreement),
    fork(watchUpdateAgreement),
    fork(watchDeleteAgreement),
    fork(watchUploadAgreementAttachments),
    fork(watchCreateFolder),
    fork(watchUpdateFolder),
    fork(watchDeleteFolder)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobAgreementSaga.js